
<template>
  <div>
      <div class="preloader" v-if="loading">
      <div class="circular-spinner">
        <img src="../assets/images/shiba-loading.png" height="200">
      </div>
      </div>
  <div class="container">
    <div class="x-language">
						<div class="current-lang -link-wrapper" @click="toggleDropdown">
							<div class="-image-wrapper">
								<img 
									class="img-fluid -ic-right-star-rank" 
									:src="getFlagImage()" 
									alt="time2lucky change language"
								>
								<span class="lang-name" v-if="isDropdownOpen">{{ getLanguageName() }}</span>
							</div>
						</div>
						<div class="lang-dropdown" v-if="isDropdownOpen">
							<div 
								v-for="lang in languages" 
								:key="lang.code"
								class="lang-option"
								@click="selectLanguage(lang.code)"
							>
								<img 
								:src="require(`../assets/images/flags/${lang.code}.png`)" 
								:alt="lang.name"
								class="flag-icon"
								>
								<span class="lang-name">{{ lang.name }}</span>
							</div>
						</div>
			</div>
      <div class="row">
          <div class="col-md-5 mx-auto">
              <div id="first">
                  <div class="myform form ">
                      <div class="logo mb-3" v-if="step !== 4">
                          <div class="col-md-12 text-center">
                              <img src="../assets/images/logo-headline65x400.png"
                                  style="max-width: 50%;margin-bottom: 15px;">
                              <div v-if="pictureUrl">
                                <img :src="pictureUrl" width="60" style="border-radius: 50%;">
                              </div>
                              <h2 v-if="step===1.2" style="color:#fff">{{ $t('register_page.verify_otp') }}</h2>
                              <h2 v-else style="color:#fff">{{ $t('register_page.title') }}</h2>
                          </div>
                      </div>
                      <div class="logo-step4" v-else>
                          <div class="logo-step4-header">
                              <img src="../assets/images/logo-headline65x400.png" class="logo-step4-img" alt="time2lucky">
                              <h3 class="register-success-title">{{ $t('register_page.register_success') }}</h3>
                          </div>
                      </div>
                      <form id="msform" name="msform" method="post" onsubmit="return false;">
                      <div class="x-step-register" v-if="step!=4">
                          <div class="px-0 m-auto -container-wrapper">
                              <div :class="{ '-step-box-outer': true, 'step-active': step==1 || step==1.2 }"></div>
                              <div :class="{ '-step-box-outer': true, 'step-active': step==2 }"></div>
                              <div :class="{ '-step-box-outer': true, 'step-active': step==3 }"></div>
                          </div>
                      </div>
                      <fieldset v-if="step==1">
                          <p class="mt-1 text-white small" style="text-align: center;">
                              {{ $t('register_page.enter_mobile') }}</p>
                          <div class="form-group">
                              <div class="input-group mb-4">
                                  <div class="input-group-prepend">
                                      <span class="input-group-text" id="basic-addon1">
                                          <i class="fa fa-user"></i>
                                      </span>
                                  </div>
                                  <input type="number" v-model="mobile" id="mobile" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10" class="form-control" :placeholder="$t('login_page.mobile')" aria-describedby="basic-addon1">
                              </div>
                          </div>
                          <div class="form-group">
                              <!--6LfgBNsoAAAAABmTJDfW02aHdozfrI1uYQvbWhZ2-->
                          <div id="recaptcha-main" class="g-recaptcha"></div>
                          </div>
                          <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                              <p class="text-center">
                                  <a class="btn btn-blu-grow" @click="checkPhone()">{{ $t('register_page.next') }} <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                              </p>
                          </div>
                          <!-- <div class="col-md-12 mb-3 text-center" style="padding-top:8px;padding-left:0px;padding-right:0px;" v-if="!userId">
                              <button type="button" class="google btn mybtn cCsozd ewHin" @click="lineLogin()"><img class="icon" src="../assets/images/icon-line.svg" alt="line">สมัครระบบด้วยไลน์</button>
                          </div> -->
                      </fieldset>
                      <fieldset v-if="step==1.2">
                          <p class="mt-1 text-white small" style="text-align: center;">{{ $t('register_page.otp_sent') }}
                          </p>
                          <p class="mt-1 text-white small" style="text-align: center;">{{ $t('register_page.mobile_number') }} {{mobileFormat()}}
                          </p>
                          <div class="form-group">
                              <input type="text" v-model="otp" class="form-control mb-3" :placeholder="$t('register_page.enter_otp')"
                                  id="otp" name="otp" style="text-align: center;" maxlength="4" >
                          </div>
                          <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                              <p class="text-center">
                                  <a class="btn btn-blu-grow" @click="checkOTP()">{{ $t('register_page.verify_otp_btn') }} <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                              </p>
                          </div>
                          <p class="mt-1 text-white small" style="text-align: center;font-size: 12px;" @click="resendOTP()"><i :class="{'fas':true, 'fa-sync-alt':true, 'f-10':true, 'fa-spin':fa_spin}"></i>&nbsp;{{ $t('register_page.resend_otp') }}
                          </p>
                          <a href="javascript:;" @click="step=1" class="previous action-button-previous"><i
                                  class="fa fa-angle-left" aria-hidden="true" style="color: #eee;"></i>
                              {{ $t('register_page.back') }}</a>
                      </fieldset>
                      <fieldset v-if="step==2">
                          <p class="mt-1 text-white small" style="text-align: center;">{{ $t('register_page.enter_password') }}
                          </p>
                          <div class="form-group">
                              <input 
                                type="password" 
                                autocomplete="new-password"
                                v-model="password" 
                                class="form-control mb-3" 
                                :placeholder="$t('login_page.password')"
                                id="password" 
                                name="password"
                              >
                              <input 
                                type="password" 
                                autocomplete="new-password"
                                v-model="password2" 
                                class="form-control" 
                                :placeholder="$t('register_page.confirm_password')"
                                id="con_password"
                              >
                          </div>
                          <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                              <p class="text-center">
                                  <a class="btn btn-blu-grow" @click="checkPassword()">{{ $t('register_page.next') }} <i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                              </p>
                          </div>
                          <a href="javascript:;" @click="step=1" class="previous action-button-previous"><i
                                  class="fa fa-angle-left" aria-hidden="true" style="color: #eee;"></i>
                              {{ $t('register_page.back') }}</a>
                      </fieldset>
                      <fieldset v-if="step==3">
                          <p class="mt-1 text-white small" style="text-align: center;">{{ $t('register_page.select_bank') }}</p>
                          <div class="form-group">
                              <select v-model="bank" class="form-control mb-3"  @change="recheckAutoGenName()">
                                  <option value="0">{{ $t('register_page.select_bank_option') }}</option>
                                  <option value="truewallet">Truewallet</option>
                                  <option value="bankokbank">BBL - ธนาคารกรุงเทพ</option>
                                  <option value="kbank">KBANK - ธนาคารกสิกรไทย</option>
                                  <option value="scb">SCB - ธนาคารไทยพาณิชย์</option>
                                  <option value="tisco">TISCO - ธนาคารทิสโก้</option>
                                  <option value="ttb">TTB - ทหารไทยธนชาต</option>
                                  <option value="ktb">KTB - ธนาคารกรุงไทย</option>
                                  <option value="krungsri">BAY - ธนาคารกรุงศรีอยุธยา</option>
                                  <option value="kiatnakin">KKP - ธนาคารเกียรตินาคิน</option>
                                  <option value="gsb">GSB - ธนาคารออมสิน</option>
                                  <option value="lh">LHBANK - ธนาคารแลนด์ แอนด์ เฮ้าส์</option>
                                  <option value="uob">UOB - ธนาคารยูโอบี</option>
                                  <option value="ธนาคารอิสลาม">IBANK - ธนาคารอิสลามแห่งประเทศไทย</option>
                                  <option value="ghbank">GHB - ธนาคารอาคารสงเคราะห์</option>
                                  <option value="cimb">CIMB - ธนาคารซีไอเอ็มบีไทย</option>
                                  <option value="baac">BAAC - ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธกส)</option>
                                  <option value="icbc">ICBC - ธนาคารไอซีบีซี (ไทย)</option>
                                  <option value="standard">STANDARD - ธนาคารสแตนดาร์ดชาร์เตอร์ดไทย</option>
                              </select>

                              <input 
                                type="text" 
                                inputmode="numeric" 
                                pattern="[0-9]*"
                                autocomplete="off"
                                class="form-control mb-3" 
                                :placeholder="$t('register_page.account_number')" 
                                v-model="account_no" 
                                @blur="checkBankAccount()"
                                @input="validateAccountNumber"
                              >
                              <input 
                                type="text" 
                                autocomplete="given-name"
                                class="form-control mb-3" 
                                :placeholder="$t('register_page.first_name')" 
                                v-model="firstname" 
                              >
                              <input 
                                type="text" 
                                autocomplete="family-name"
                                class="form-control " 
                                :placeholder="$t('register_page.last_name')" 
                                v-model="lastname" 
                              >
                              <!-- <div>
                                  <label for="f-option" class="l-radio">
                                      <input type="radio" id="f-option" name="prostatus" value="Y" tabindex="1">
                                      <span>รับโบนัส</span>
                                  </label>
                                  <label for="s-option" class="l-radio">
                                      <input type="radio" id="s-option" name="prostatus" value="N" tabindex="2"
                                          checked="checked">
                                      <span>ไม่รับโบนัส</span>
                                  </label>
                              </div> -->

                          </div>
                          <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                              <p class="text-center">
                                  <a class="btn btn-blu-grow" @click="register()">{{ $t('register_page.register') }} <i class="fa fa-user-circle" aria-hidden="true"></i></a>
                              </p>
                          </div>
                          <a href="javascript:;"  @click="step=2" class="previous action-button-previous"><i
                                  class="fa fa-angle-left" aria-hidden="true" style="color: #eee;"></i>
                              {{ $t('register_page.back') }}</a>
                      </fieldset>
                      <fieldset v-if="step==4">
                          <p class="mt-1 text-white small" style="text-align: center;">{{ $t('register_page.thank_you_message') }}</p>
                          <div class="bg_register_user_new text-left">
                              <div class="register-info-row">
                                <span class="register-info-label">{{ $t('register_page.username') }} :</span>
                                <span class="register-info-value" id="txt_username">{{mobile}}</span>
                              </div>
                              <div class="register-info-row">
                                <span class="register-info-label">{{ $t('register_page.password_label') }} :</span>
                                <span class="register-info-value" id="txt_password">{{password}}</span>
                              </div>
                          </div>
                          <div class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                              <p class="text-center">
                                  <a class="btn btn-blu-grow" @click="gotoLogin()">{{ $t('register_page.go_to_login') }} <i class="fa fa-sign-in" aria-hidden="true"></i></a>
                              </p>
                          </div>
                          <div v-if="anoucement && anoucement.image" class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                            <div class="text-center">
                              <img :src="anoucement.image" alt="Announcement time2lucky" class="img-fluid announcement-image">
                            </div>
                          </div>
                          <div v-if="anoucement && anoucement.status" class="col-md-12 mb-3" style="padding-left:0px;padding-right:0px;">
                            <div class="text-center" v-html="anoucement.detail"></div>
                          </div>
                          <div class="col-md-12 mb-3 text-center" style="padding-left:0px;padding-right:0px;">
                            <p class="text-white small mb-2">{{ $t('register_page.contact_admin_text') }}</p>
                            <a :href="adminContactLineLink" target="_blank" class="btn-line-contact">
                              <img src="../assets/images/icon-line.svg" alt="LINE" class="line-icon"> {{ $store.getters['settings/lineAt'] }}
                            </a>
                          </div>
                          <div
                            class="x-modal modal"
                            id="ads-no-show-again"
                            tabindex="-1"
                            role="dialog"
                            aria-hidden="true"
                            data-loading-container=".js-modal-content"
                            data-ajax-modal-always-reload="true"
                            data-modal-one-time="Announcement Banner 1"
                            data-check-target="#ads-no-show-again"
                          >
                            <div class="modal-dialog -modal-size " role="document">
                              <div class="modal-content -modal-content">
                                <button
                                  type="button"
                                  class="close f-1 "
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <i class="fas fa-times"></i>
                                </button>
                                <div class="modal-header -modal-header">
                                  <h3 class="x-title-modal d-inline-block m-auto">
                                    <span>{{ $t('register_page.important_notice') }}</span>
                                  </h3>
                                </div>
                                <div class="modal-body -modal-body">
                                  <div class="important-notice-detail">{{ $t('register_page.important_notice_detail') }}</div>
                                  <div class="my-3">
                                    <a
                                      data-dismiss="modal"
                                      class="text-black btn btn-block -submit btn-primary text-center m-auto"
                                    >
                                      <span>{{ $t('register_page.acknowledge') }}</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                      </fieldset>
                      </form>
                      <template v-if="step!=4">
                          <div class="col-md-12 ">
                              <div class="login-or">
                                  <hr class="hr-or">
                                  <span class="span-or">{{ $t('register_page.or') }}</span>
                              </div>
                          </div>

                          <div class="col-md-12 mb-3">
                              <div class="text-center" style="color: #FFF;">
                                  {{ $t('register_page.already_have_account') }} <router-link to="/login" style="color: #fec33f;text-decoration: underline !important;">{{ $t('register_page.login') }}</router-link> / <a :href="$store.getters['settings/linkLine']" style="color: #fec33f;text-decoration: underline !important;" target="_blank">{{ $t('register_page.contact_admin') }}</a>
                              </div>
                          </div>
                      </template>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
</template>

<script>

import queryString from 'querystring'
import firebase from 'firebase/app'
import 'firebase/database'
import router from './../router'
import settingsMixin from '@/mixins/settingsMixin'
const axios = require('axios').default
const qs = require('qs')
export default {
name: 'Login',
mixins: [settingsMixin],
async created () {
  const user = localStorage.getItem('userData')
  if (user) {
    const _user = JSON.parse(user)
    if (_user && _user.key && firebase.auth().currentUser) {
      router.replace('/')
    }
  }
  const { code, prefix, ref } = queryString.parse(window.location.search.replace('?', ''))
  this.persistReferralData({ prefix, ref })
  if (!code) return
  const result = await this.getToken(code)
  if (result && result.access_token) {
    const { data } = await this.getProfile(result.access_token)
    this.checkLineLogin(data)
  }
},
data () {
  return {
    isDropdownOpen: false,
      languages: [
        { code: 'th', name: 'ไทย' },
        { code: 'en', name: 'English' },
        { code: 'my', name: 'မြန်မာ' },
      ],
    autogenname:true,
    token: '',
    otp: '',
    fa_spin: false,
    mobile: '',
    step: 1,
    password: '',
    password2: '',
    bank: 0,
    firstname: '',
    lastname: '',
    account_no: '',
    loading: false,
    userFriendId: '',
    clientId: '1656935750',
    callbackUri: 'https://time2lucky.com/register',
    clientSecret: '4b4c6d35256b0034244f1a0056ddb640',
    pictureUrl: '',
    userId: '',
    smsotp: { status: '', token: '', refno: '' },
    anoucement: {},
    recaptchaWidgetId: null,
  }
},
mounted () {
  this.syncLanguageFromStorage()
  this.renderRecaptchaForLocale()
  // this.getSetting();
  const userData = localStorage.getItem('userId')
  if (userData) {
    try {
      const user = JSON.parse(userData)
      this.userId = user.userId
      this.pictureUrl = user.pictureUrl
    } catch (error) {

    }
  }
  window.myRecaptchaMethod = this.myRecaptchaMethod;
},
watch: {
  '$route.query' (newQuery) {
    this.persistReferralData(newQuery || {})
  }
},
methods: {
  syncLanguageFromStorage () {
    const language = this.getStoredLanguage()
    this.$i18n.locale = language
    document.documentElement.lang = language
  },
  getStoredLanguage () {
    const validLanguages = this.languages.map(lang => lang.code)
    try {
      const userData = JSON.parse(localStorage.getItem('userData')) || {}
      return validLanguages.includes(userData.language) ? userData.language : 'th'
    } catch (error) {
      return 'th'
    }
  },
  persistReferralData (query = {}) {
    const prefixValue = this.normalizeQueryValue(query.prefix)
    const refValue = this.normalizeQueryValue(query.ref)

    if (prefixValue) {
      localStorage.setItem('prefix', prefixValue)
    }
    if (refValue) {
      localStorage.setItem('ref', refValue)
    }

    const storedRef = localStorage.getItem('ref')
    this.userFriendId = storedRef ? storedRef : ''
  },
  normalizeQueryValue (value) {
    if (Array.isArray(value) && value.length > 0) {
      const candidate = value[0]
      return typeof candidate === 'string' ? candidate.trim() : ''
    }
    return typeof value === 'string' ? value.trim() : ''
  },
  toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectLanguage(langCode) {
      // Update user language in database
      const userData = JSON.parse(localStorage.getItem('userData')) || {};
      userData.language = langCode;
      localStorage.setItem('userData', JSON.stringify(userData));
      
      // Update Vuex store
      this.$i18n.locale = langCode;
      document.documentElement.lang = langCode;
      this.renderRecaptchaForLocale();
      
      this.isDropdownOpen = false;
    },
    getLanguageName () {
      const language = this.$i18n.locale || this.getStoredLanguage();
      const lang = this.languages.find(lang => lang.code === language);
      return lang ? lang.name : 'ไทย';
    },
    getFlagImage() {
      const language = this.$i18n.locale || this.getStoredLanguage();
      const validLanguages = this.languages.map(lang => lang.code);
      
      if (validLanguages.includes(language)) {
        return require(`../assets/images/flags/${language}.png`);
      }
      
      return require('../assets/images/flags/th.png');
    },
  getRecaptchaLanguageCode (langCode) {
    const recaptchaLanguages = {
      th: 'th',
      en: 'en',
      my: 'my'
    }
    return recaptchaLanguages[langCode] || 'th'
  },
  loadRecaptchaScript (langCode) {
    const recaptchaLang = this.getRecaptchaLanguageCode(langCode)
    const existingScript = document.getElementById('recaptcha-api')

    return new Promise((resolve) => {
      const waitForApi = () => {
        if (window.grecaptcha && window.grecaptcha.render) {
          resolve()
          return
        }
        setTimeout(waitForApi, 50)
      }

      if (existingScript && existingScript.getAttribute('data-lang') === recaptchaLang) {
        waitForApi()
        return
      }

      if (existingScript && existingScript.parentNode) {
        existingScript.parentNode.removeChild(existingScript)
      }

      try {
        delete window.grecaptcha
        delete window.___grecaptcha_cfg
      } catch (error) {
        window.grecaptcha = undefined
        window.___grecaptcha_cfg = undefined
      }

      const script = document.createElement('script')
      script.id = 'recaptcha-api'
      script.setAttribute('data-lang', recaptchaLang)
      script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${recaptchaLang}`
      script.async = true
      script.defer = true
      script.onload = waitForApi
      document.body.appendChild(script)
    })
  },
  async renderRecaptchaForLocale () {
    const element = document.getElementById('recaptcha-main')
    if (!element) return

    this.token = ''
    this.recaptchaWidgetId = null
    element.innerHTML = ''

    await this.loadRecaptchaScript(this.$i18n.locale)
    if (!window.grecaptcha || !window.grecaptcha.render) return

    this.recaptchaWidgetId = window.grecaptcha.render('recaptcha-main', {
      sitekey: '6LfwndEtAAAAAONTQruy4hk6uHxH7s09ZVVpO84n',
      callback: this.myRecaptchaMethod
    })
  },
  recheckAutoGenName() {
      if(this.bank === 'truewallet'){ 
        this.autogenname = false;
        this.firstname = '';
        this.lastname = '';
      }else{
        this.autogenname = true;
      }
      if(this.bank && this.account_no){
        this.checkBankAccount();
      }
  },
  validateAccountNumber(event) {
    // Allow only numeric characters for account number
    const value = event.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    
    // Update the model with cleaned value
    this.account_no = numericValue;
    
    // Limit length based on bank type
    if (this.bank === 'truewallet' && numericValue.length > 10) {
      this.account_no = numericValue.slice(0, 10);
    } else if (this.bank !== 'truewallet' && numericValue.length > 15) {
      this.account_no = numericValue.slice(0, 15);
    }
    
    // Update the input value to reflect the cleaned value
    event.target.value = this.account_no;
  },
  myRecaptchaMethod(recaptchaResponse) {
    // ทำการยืนยัน reCAPTCHA และกระทำตามคำตอบที่ได้รับ
    this.token = recaptchaResponse;
  },
  resendOTP () {
    this.fa_spin = true
    this.checkPhone()
    setTimeout(() => {
      this.fa_spin = false
    }, 3000)
  },
  async checkOTP () {
    // if (!this.otp) {
    //   this.$swal({ icon: 'error', title: 'OTP!', text: 'โปรดระบุ OTP ที่ได้รับ!!!' })
    //   return
    // }else {
    //   axios({
    //     method: 'post',
    //     url: 'https://time2lucky.apifast.xyz/api/checkotp',
    //     data: {
    //       pin: this.otp,
    //       token: this.smsotp.token
    //     }
    //   }).then(async res => {
    //     if(res.data && res.data.status){
    //       this.step = 2
    //     }else{
    //       this.$swal({ icon: 'error', title: 'OTP!', text: 'OTP ไม่ถูกต้องโปรดตรวจสอบ OTP ใหม่!!!' })
    //     }
    //   });
    // }
    const otp = (await firebase.database().ref(`/otpsms/${this.mobile}/value`).once('value')).val()
    if (!this.otp) {
      this.$swal({ icon: 'error', title: 'OTP!', text: this.$t('register_page.please_enter_otp') })
      return
    }
    if (otp) {
      if (this.otp == otp) {
        this.step = 2
      } else {
        this.$swal({ icon: 'error', title: 'OTP!', html: this.$t('register_page.otp_incorrect') })
      }
    } else {
      this.$swal({ icon: 'error', title: 'OTP!', text: this.$tWithSettings('register_page.otp_not_found') })
    }
  },
  mobileFormat () {
    if (this.mobile) {
      return `0XX-XXXX-${this.mobile.toString().slice(-3)}`
    }
  },
  // lineLogin () {
  //   const url = 'https://access.line.me/oauth2/v2.1/authorize'
  //   let params = {
  //     response_type: 'code',
  //     client_id: this.clientId,
  //     redirect_uri: this.callbackUri,
  //     state: Math.random().toString(32).substring(2),
  //     scope: 'openid profile'
  //   }
  //   if (this.addFriend) {
  //     params = Object.assign(params, {
  //       prompt: 'consent',
  //       bot_prompt: 'aggressive'
  //     })
  //   }
  //   window.location.href = `${url}?${queryString.stringify(params)}`
  // },
  checkLineLogin (data) {
    this.loading = true
    axios({
      method: 'post',
      url: 'https://time2lucky.apifast.xyz/api/loginline',
      data: {
        userId: data.userId,
        pictureUrl: data.pictureUrl
      }
    }).then(async res => {
      if (res && res.data && res.data.status) {
        firebase.auth().signInWithEmailAndPassword(res.data.mobile.trim().toLowerCase() + '@time2lucky.com', res.data.password.trim()).then(async (res) => {
          if (res.user) {
            router.replace('/')
          } else {
            this.error = this.$tWithSettings('register_page.contact_admin_error')
          }
          this.loading = false
        }).catch(() => {
          this.$swal({ icon: 'error', title: this.$t('register_page.message'), text: this.$t('register_page.mobile_password_error') })
          this.loading = false
        })
      } else {
        localStorage.setItem('userId', JSON.stringify(data))
        this.userId = data.userId
        this.pictureUrl = data.pictureUrl
        this.loading = false
      }
    })
  },
  async getToken (code) {
    const data = qs.stringify({
      grant_type: 'authorization_code',
      code,
      redirect_uri: this.callbackUri,
      client_id: this.clientId,
      client_secret: this.clientSecret
    })
    let response
    await axios({
      method: 'post',
      url: 'https://api.line.me/oauth2/v2.1/token',
      data: data
    }).then(async res => {
      if (res.status !== 200) {
        this.error = this.$tWithSettings('register_page.contact_admin_error')
      } else if (res.data) {
        response = res.data
      }
    })
    return response
  },
  async getProfile (token) {
    return await axios.get('https://api.line.me/v2/profile', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },
  async checkFriend (token) {
    const { data } = await axios.get('https://api.line.me/friendship/v1/status', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return data.friendFlag
  },
  async checkName () {
      let check = false
      await axios({
        method: 'post',
        url: 'https://time2lucky.apifast.xyz/api/checkname',
        data: {
          firstname: this.firstname.toString().trim(),
          lastname: this.lastname.toString().trim()
        }
      }).then(async response => {
        if (!response.data.status) {
          this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.name_exists_error') })
          this.firstname = ''
          this.lastname = ''
          check = true
        }
      })
      return check
    },
  async register () {
    if (this.bank === 0) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_select_bank') })
    } else if (this.account_no.trim() === '') {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_enter_account_number') })
    } else if (this.firstname.trim() === '') {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_enter_first_name') })
    } else if (this.lastname.trim() === '') {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_enter_last_name') })
    } else if (!/^[ก-๙a-zA-Z\u1000-\u109F\s.\-]+$/.test(this.firstname) || !/^[ก-๙a-zA-Z\u1000-\u109F\s.\-]+$/.test(this.lastname)) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.invalid_name_error') })
    } else {
      this.loading = true
      let check = false
      check = await this.checkBankAccount()
      if (!check) {
        const checkname = await this.checkName()
        if (!checkname) {
          await this.getAnoucementRegister()
          axios({
            method: 'post',
            url: 'https://time2lucky.apifast.xyz/api/createuser',
            data: {
              firstname: this.firstname.toString().trim(),
              lastname: this.lastname.toString().trim(),
              bank: this.bank,
              account_no: this.account_no,
              tel: this.mobile,
              password: this.password,
              userFriendId: (localStorage.getItem('ref')) ? localStorage.getItem('ref') : '',
              agent: (localStorage.getItem('prefix')) ? localStorage.getItem('prefix') : '',
              userId: this.userId,
              pictureUrl: this.pictureUrl
            }
          }).then(async response => {
            this.loading = false
            if (!response.data.status) {
              if (response.data.error === 'duplicate_account') {
                await this.$showDuplicateAccountContactAlert()
                this.account_no = ''
              } else {
                this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.registration_problem') })
              }
            } else {
                if (response.data.refNotFound) {
                  await this.$swal({ icon: 'info', title: this.$t('register_page.message'), text: 'ไม่มีผู้แนะนำ' })
                }
              this.step = 4
              $('#ads-no-show-again').modal('show')
              localStorage.removeItem('userId')
              localStorage.removeItem('prefix')
              localStorage.removeItem('ref')
            }
          })
        }
      }
      this.loading = false
    }
  },
  async getAnoucementRegister () {
    const anoucement = (await firebase.database().ref('/anoucement_register/1').once('value')).val()
    if (anoucement && anoucement.status) {
      this.anoucement = anoucement
    }
  },
  async checkBankAccount () {
    if (!this.account_no || !this.bank) return true

    try {
      const accountNo = this.account_no.trim()
      const response = await axios.get(
        `https://time2lucky.apifast.xyz/api/checkaccount/${encodeURIComponent(accountNo)}/${encodeURIComponent(this.bank)}`
      )
      if (response.data && response.data.status) return false

      if (response.data && response.data.error === 'account_check_unavailable') {
        this.$swal({ icon: 'error', title: 'Error!', text: 'ระบบไม่สามารถตรวจสอบเลขบัญชีซ้ำได้ กรุณาลองใหม่อีกครั้ง' })
      } else {
        await this.$showDuplicateAccountContactAlert()
        this.account_no = ''
      }
      return true
    } catch (error) {
      this.$swal({ icon: 'error', title: 'Error!', text: 'ระบบไม่สามารถตรวจสอบเลขบัญชีซ้ำได้ กรุณาลองใหม่อีกครั้ง' })
      return true
    }
  },
  gotoLogin () {
    router.replace('/login')
  },
  checkPassword () {
    if (this.password.toString().trim().length < 6) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.password_length_error') })
    } else if (this.password !== this.password2) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.password_mismatch') })
    } else {
      this.step = 3
    }
  },
  async checkPhone () {
    if (!this.mobile.toString().trim()) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_enter_mobile') })
    } else if (this.mobile.toString().trim().length !== 10) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.mobile_length_error') })
    } else if (!this.token) {
      this.$swal({ icon: 'error', title: 'Error!', text: this.$t('register_page.please_verify_identity') })
    } else {
      const check = (localStorage.getItem('ref'))?'y':'n';
      await axios({
          method: 'post',
          url: 'https://time2lucky.apifast.xyz/api/checkmoble',
          data: {
              mobile: this.mobile.trim(),
              ref: check,
              token: this.token
          }
      }).then(async (response)=>{
          if (!response.data.status) {
              if(response.data.error){
              this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.contact_admin_error') });
              }else{
              this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.mobile_exists_error') })
              }
          } else {
              const sms = (await firebase.database().ref('/sms').once('value')).val()
              if (sms && sms.status && check === 'n') {
              //this.smsotp = response.data.data
              this.step = 1.2
              } else {
              this.step = 2
              }
          }
      })
      /*
      axios({
        method: 'get',
        url: 'https://time2lucky.apifast.xyz/api/checkmobi1e/' + this.mobile.trim()+'/'+check
      }).then(async response => {
        if (!response.data.status) {
          if(response.data.error){
            this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.contact_admin_error') });
          }else{
            this.$swal({ icon: 'error', title: 'Error!', text: this.$tWithSettings('register_page.mobile_exists_error') })
          }
        } else {
          const sms = (await firebase.database().ref('/sms').once('value')).val()
          if (sms && sms.status && check === 'n') {
            //this.smsotp = response.data.data
            this.step = 1.2
          } else {
            this.step = 2
          }
        }
      })*/
    }
  }
}
}
</script>
<style scoped>
.x-step-register {
  margin: 0rem 0 2.2rem;
}
.important-notice-detail {
  font-size: 18px;
  font-family: 'Kanit', sans-serif;
  padding-top: 20px;
  white-space: pre-line;
}
.m-auto {
  margin: auto!important;
}
.x-step-register .-container-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 4px;
  background: linear-gradient(
90deg
,#fe8a02,#ffe867);
  overflow: hidden;
}
.x-step-register .-container-wrapper .-step-box-outer.step-active {
  background-color: transparent;
}
.x-step-register .-container-wrapper .-step-box-outer {
  display: flex;
  justify-content: flex-end;
  width: 40px;
  height: 8px;
  background-color: #d2d2d2;
}
.x-step-register .-container-wrapper .-step-box-outer:not(:last-of-type):after {
  content: "";
  display: block;
  width: 2px;
  height: 8px;
  background-color: #6C0D0E;
}
.ewHin {
  background: rgb(0, 187, 0);
  color: rgb(255, 255, 255);
  height: 50px;
  min-width: 180px;
  border-radius: 25px;
  padding-left: 34px;
  padding-right: 34px;
}
.cCsozd {
  display: inline-block;
  padding: 0.5rem 1rem;
  height: 44px;
  font-size: 1em;
  line-height: 1.5;
  border: none;
  border-radius: 0.25rem;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
}
.ewHin .icon {
  height: 18px;
  margin: 0px 0.5rem;
  vertical-align: sub;
  border: 0px;
}
.g-recaptcha {
    display: flex !important;
    justify-content: center !important;
    padding-bottom: 5px;
}


.x-language{position:absolute;right:0;top:100px;z-index:6;margin-right: -4px;}
@media (max-width:1199.98px){
	.x-language{/*position:relative;top:unset;z-index:unset;display:flex*/}
}
.x-language .-link-wrapper{
	background-color:rgba(0,0,0,.5);border-top-left-radius:20px;border-bottom-left-radius:20px;display:flex;padding:.4rem .75rem;color:#fff;align-items: center;
}
@media (min-width:1200px){
	.x-language .-link-wrapper:hover{text-decoration:none;background-color:rgba(0,0,0,.4)}
}@media (max-width:1199.98px){
	.x-language .-link-wrapper{padding:5px;margin-right:.5rem}
}@media (max-width:575.98px){
	.x-language .-link-wrapper{margin-right:.25rem}
}
.x-language .-link-wrapper .-image-wrapper{
	align-items:center;display:flex
}
.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{width:30px}
@media (max-width:370px){
	.x-language .-link-wrapper .-image-wrapper .-ic-right-star-rank{min-width:25px}
}
.x-language .-link-wrapper .-text-wrapper{
	line-height:16px;font-size:1.1rem;margin-left:.5rem;
	display: block;
}
/* Quill alignment helpers for frontend rendering */
.ql-align-center { text-align: center; }
.ql-align-right { text-align: right; }
.ql-align-justify { text-align: justify; }
.ql-direction-rtl { direction: rtl; }

/* Ensure embeds and images align correctly */
.ql-align-center img,
.ql-align-center iframe,
.ql-align-center video {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.ql-align-right img,
.ql-align-right iframe,
.ql-align-right video {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

/* New Register Success UI */
.bg_register_user_new {
  background: #fff;
  border-radius: 10px;
  padding: 15px 20px;
  margin-bottom: 15px;
}
.register-info-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 0;
  font-size: 16px;
  color: #333;
}
.register-info-label {
  font-weight: 500;
  min-width: 80px;
}
.register-info-value {
  font-weight: 600;
  margin-left: 10px;
}
.announcement-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}
.btn-line-contact {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #00B900;
  color: #fff;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}
.btn-line-contact:hover {
  background: #009900;
  color: #fff;
  text-decoration: none;
  transform: scale(1.05);
}
.btn-line-contact .line-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

/* Step 4 Logo Layout */
.logo-step4 {
  margin-bottom: 15px;
}
.logo-step4-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}
.logo-step4-img {
  max-width: 100px;
  height: auto;
}
.register-success-title {
  font-size: 16px;
  font-weight: 500;
  color: #fec33f !important;
  margin: 0;
}

</style>
